module.exports = __webpack_public_path__ + "media/images/features/draft/icon-flow-03-6334eb437f8fbf76591ebfbd7fec978b.svg";